/** reCAPTCHA public key. Duplicated in viewbuff/volumes/keys/recaptcha.json or /etc/viewbuff */
export const RECAPTCHA_PUBLIC_KEY = '6LeUtYEdAAAAAJhWHTeC6T_l05xGPUoOqsMU0J2C';

/** in a testing environment, this will always be a valid recaptcha token */
export const TEST_RECAPTCHA_TOKEN = 'TEST_RECAPTCHA_TOKEN';
